import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { UserProvider } from './utils/context/user/index.jsx'
import "@fontsource/poppins/400.css" // Regular
import "@fontsource/poppins/600.css" // SemiBold
import "@fontsource/poppins/700.css" // Bold


ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    
      <App />
    
  </React.StrictMode>,
)
